// Partner cart sharing (e.g. Tildei itinerary builder).
// Partners push a cart to /1/partner-carts and redirect the user to
// /cart?itinerary_id=<id>; this module loads it and keeps the attribution
// until the order is placed.
import { request } from 'utils/api';
import { localStorage } from 'utils/helpers';

const STORAGE_KEY = 'externalCart';
const ITINERARY_PARAMS = ['itinerary_id', 'itineraryId'];

export function getItineraryIdParam(search) {
  const params = new URLSearchParams(search);
  const param = ITINERARY_PARAMS.find((name) => params.get(name));
  return param ? params.get(param) : null;
}

export function removeItineraryIdParam(search) {
  const params = new URLSearchParams(search);
  ITINERARY_PARAMS.forEach((name) => params.delete(name));
  const query = params.toString();
  return query ? `?${query}` : '';
}

export function fetchPartnerCart(itineraryId) {
  return request({
    method: 'GET',
    path: `/1/partner-carts/${encodeURIComponent(itineraryId)}`,
  }).then(({ data }) => data);
}

export function getExternalCart() {
  try {
    const externalCart = JSON.parse(localStorage.getItem(STORAGE_KEY));
    if (!externalCart?.id || !externalCart?.source) return null;
    // Attribution lasts as long as the partner cart itself.
    if (new Date(externalCart.expiresAt) <= new Date()) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return externalCart;
  } catch (error) {
    localStorage.removeItem(STORAGE_KEY);
    return null;
  }
}

export function setExternalCart({ id, source, expiresAt }) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ id, source, expiresAt }));
}

// Body fields for POST /1/orders.
export function getExternalAttribution() {
  const externalCart = getExternalCart();
  if (!externalCart) return {};
  return {
    externalId: externalCart.id,
    externalSource: externalCart.source,
  };
}

// Value reported to GA4, e.g. "tildei_<itineraryId>".
export function getAnalyticsExternalId() {
  const externalCart = getExternalCart();
  return externalCart ? `${externalCart.source}_${externalCart.id}` : undefined;
}

// TODO(GTM/GA4): pending configuration, owned by us.
// - GTM: create a Data Layer Variable "external_id" and send it as an event
//   parameter named "external_id" from the GA4 configuration/event tags.
// - GA4: Admin > Custom definitions > create an event-scoped custom dimension
//   "external_id" (reusable for future third-party integrations).
// Expected value: "tildei_<itineraryId>"; it is reset to undefined after the
// order is placed so later sessions are not attributed to the partner.
export function pushExternalIdToDataLayer() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ external_id: getAnalyticsExternalId() });
}

export function clearExternalCart() {
  localStorage.removeItem(STORAGE_KEY);
  pushExternalIdToDataLayer();
}
